import React from 'react';
import { User, Users, Clock, Repeat, Pause, Play, Zap, Trash2 } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { daysOfWeek, getVisitTypeColor } from './schedulingConstants';

export function TemplateCard({ 
  template, 
  onToggleActive, 
  onGenerateClick, 
  onDelete 
}) {
  return (
    <Card className={`${!template.is_active ? 'opacity-60' : ''}`} data-testid={`template-${template.id}`}>
      <CardContent className="pt-6">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getVisitTypeColor(template.visit_type)}`}>
              <Repeat className="w-5 h-5" />
            </div>
            <div>
              <h3 className="font-semibold">{template.name}</h3>
              <Badge variant="outline" className={`text-xs mt-1 ${template.is_active ? 'border-green-300 text-green-700' : 'border-slate-300 text-slate-500'}`}>
                {template.is_active ? 'Active' : 'Paused'}
              </Badge>
            </div>
          </div>
        </div>

        <div className="space-y-2 text-sm">
          <p className="flex items-center gap-2">
            <User className="w-4 h-4 text-slate-400" />
            <span className="text-slate-600">{template.staff_name}</span>
          </p>
          <p className="flex items-center gap-2">
            <Users className="w-4 h-4 text-slate-400" />
            <span className="text-slate-600">{template.client_name}</span>
          </p>
          <p className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-slate-400" />
            <span className="text-slate-600">{template.start_time} - {template.end_time}</span>
          </p>
        </div>

        <div className="flex flex-wrap gap-1 mt-3">
          {daysOfWeek.filter(d => template.days_of_week?.includes(d.id)).map(day => (
            <Badge key={day.id} variant="outline" className="text-xs">{day.short}</Badge>
          ))}
        </div>

        <div className="flex gap-2 mt-4 pt-4 border-t">
          <Button
            size="sm"
            variant="outline"
            onClick={() => onToggleActive(template)}
          >
            {template.is_active ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
          </Button>
          <Button 
            size="sm" 
            variant="outline" 
            onClick={() => onGenerateClick(template)} 
            disabled={!template.is_active}
          >
            <Zap className="w-4 h-4 mr-1" /> Generate
          </Button>
          <Button size="sm" variant="destructive" onClick={() => onDelete(template.id)}>
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
